const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoAddressBlockingQuery: any = {
    GetBlockedAddresses: Backofficebff + '/v1/deliveryservice/get-blocked-addresses',
};
